import { render } from "./ClientHistoryDialogDetail.vue?vue&type=template&id=87621c1e&scoped=true"
import script from "./ClientHistoryDialogDetail.vue?vue&type=script&lang=ts"
export * from "./ClientHistoryDialogDetail.vue?vue&type=script&lang=ts"

import "./ClientHistoryDialogDetail.vue?vue&type=style&index=0&id=87621c1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-87621c1e"

export default script